module.exports = __webpack_public_path__ + "76fade9580aea070c081c8ba1dc1aab2.svg";